import Link from 'next/link';

// Components
import Icon from '@/components/base/Icon';
import Iconosquare from '@/components/icons/Iconosquare';
import { TransitionWrapper } from '@/components/layouts/LayoutPlatform/components/Menu/components/TransitionWrapper';

export function MenuHeader({ isMenuOpen, toggleStickyMenu }) {
    return (
        <div className="mb-10 flex items-center justify-between gap-2 px-3 pt-3">
            <div className="flex items-center gap-[9px]">
                <Link href="/" className="inline-block leading-none" data-testid="link-home-page">
                    <Iconosquare size={24} className="text-icoBlue" />
                </Link>
                <TransitionWrapper isOpen={isMenuOpen}>iconosquare</TransitionWrapper>
            </div>
            <button onClick={toggleStickyMenu} className="flex" data-testid="close-menu-button">
                <Icon
                    icon="sidebar"
                    className="text-icoGray-500 transition-all duration-300 hover:text-icoBlue dark:text-icoDarkMode-wolf"
                />
            </button>
        </div>
    );
}
